module.exports = __webpack_public_path__ + "static/media/app.98368292.png";